function toggleFilters() {
    const filters = document.querySelector('.js_searchFilterWrap');
    const filtersInner = document.querySelector('.js_sideSearchFilterWrap');
    const button = getButton();
    const grid = document.querySelector('.js_vehicleCardsGrid');
    const searchWrap = document.querySelector('.js_searchListingWrap');

    let isVisible = false

    if (button) {
        button.classList.toggle('sideFilterToggleDesktop--show');
        isVisible = !button.classList.contains('sideFilterToggleDesktop--show')
    }

    if (filters) {
        filters.classList.toggle('searchFilterWrap--hidden');
        isVisible = !filters.classList.contains('searchFilterWrap--hidden')
    }

    if (filtersInner) {
        if (filtersInner.classList.contains('sideSearchFilterWrap--hideScrollBars')) {
            setTimeout(() => filtersInner.classList.remove('sideSearchFilterWrap--hideScrollBars'), 300);
            isVisible = true;
        } else {
            filtersInner.classList.add('sideSearchFilterWrap--hideScrollBars')
            isVisible = false;
        }
    }

    if (grid) {
        grid.classList.toggle('vehicleCardsGrid--fullWidth');
        isVisible = !grid.classList.contains('vehicleCardsGrid--fullWidth')
    }

    if (searchWrap) {
        searchWrap.classList.toggle('searchListingWrap--filterHidden');
        isVisible = !searchWrap.classList.contains('searchListingWrap--filterHidden')
    }

    const visibility = isVisible ? 'visible' : 'hidden'
    setVisibilityOnSession(visibility)

}

function getButton() {
    return document.querySelector('.js_sideFilterToggleDesktop');
}

async function setVisibilityOnSession(visibility) {
    const formData = new FormData()
    formData.append('search_filters_visibility', visibility)

    try {
        const res = await fetch('/modules/Search/set_search_filters_visibility.php', {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json'
            }),
            credentials: 'same-origin',
            body: formData
        })

        const body = await res.json()

        if (!res.ok) {
            return await Promise.reject(body);
        }
    } catch (e) {
        console.error(e)
    }
}

export function initToggleFilters() {
    const button = getButton();

    if (button) {
        button.addEventListener('click', toggleFilters);
    }
}

$(document).ready(initToggleFilters);
